import { useApiQuery } from 'theSource/utils';
import { LifeEventChangesResponseDto } from './types';
import {
  LIFE_EVENT_CHANGES_QUERY_KEY,
} from './utils';

export interface UseLifeEventChangesQueryProps {
  enabled: boolean;
  lifeEventId?: string;
}

export const useLifeEventChangesQuery = ({
  enabled,
	lifeEventId
}: UseLifeEventChangesQueryProps) => {
  const {
    data,
    isLoading,
    isFetching,
  } = useApiQuery<LifeEventChangesResponseDto>({
    queryKey: LIFE_EVENT_CHANGES_QUERY_KEY,
    endpoint: `/life_events/${lifeEventId}/changes`,
    showErrorSnackbar: false,
    enabled: enabled && Boolean(lifeEventId),
  });

  return {
    data,
    isLoading,
    isFetching,
  };
};
